import Cookies from "js-cookie";
import React, { useContext, useEffect, useState } from "react";
import { AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import SwalToast from "../../../components/helpers/SwalToast";
import httpclient from "../../../components/httpclient";
import Title from "../../../components/common/Title/Title";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import IsEmpty from "../../../components/helpers/IsEmpty";
import { Modal, Button, Input } from "antd";
import "antd/dist/antd.css";
import "./styles.css";
import CustomTable from "../../../components/common/Table/CustomTable";
import { PermissionContext } from "../../../components/context/PermissionContext";
import Swal from "sweetalert2";
import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";
import { initFilterInput, renderColumns } from "./constans";
import { Form } from "react-bootstrap";
import AppRoutePath from "../../../router/AppRoutePath";
import { Link } from "react-router-dom";

const OutletAppraiserList = () => {
  const [records, setRecords] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [filterInput, setFilterInput] = useState(initFilterInput);

  useEffect(() => {
    getData();
  }, [filterInput]);

  const handleTableChange = (pagination) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      pageSize: parseInt(pagination.pageSize),
    }));
  };

  const handleDelete = (record) => {
    setSubmitting(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet-appraiser/${record.id}`;

    Swal.fire({
      title: "Hapus Data",
      text: "Apakah anda yakin ingin menghapus juru Taksir outlet " + record.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        httpclient
          .DELETE(url)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            getData();
            setSubmitting(false);
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
              setSubmitting(false);
            }
          });
      }
    });
  };

  const getData = () => {
    setLoading(true);
    let params = {
      name: filterInput.searchName,
      page: filterInput.page,
      size: filterInput.pageSize,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet-appraiser`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        setLoading(false);
        setRecords(response.data.data.items);
        setTablePagination({
          current: response.data.data.page,
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  return (
    <>
      <div>
        <div className="px-3">
          <div className="py-4 d-flex flex-column" style={{ fontSize: "13px" }}>
            <Title text={"Juru Taksir per Outlet"} />
            <Breadcrumb current={"Juru Taksir per Outlet"} />
          </div>
          <div className="d-flex pt-3">
            <div className="">
              <div>Nama Juru Taksir :</div>
              <input
                type="text"
                className="form-control border-97A0AE"
                placeholder="Cari Nama"
                // onChange={(e) => this.searchData(e.target.value)}
              />
            </div>

            <CanAccess
              role={AuthorizationList.create_outlet_appraiser}
              yes={
                <Link className="ml-auto" to={AppRoutePath.APPRAISER_ADD_BY_OUTLET}>
                  <button className="ml-3 btn border-438EBC bgc-2C465C text-white font-weight-semi-bold">
                    + Tambah Juru Taksir
                  </button>
                </Link>
              }
            />
          </div>
          <div style={{ marginTop: 24 }}>
            <CustomTable
              columns={renderColumns(handleDelete)}
              data={records}
              loading={loading}
              handleTableChange={handleTableChange}
              pagination={tablePagination}
            />
          </div>
        </div>
      </div>

      
    </>
  );
};

export default OutletAppraiserList;
